'use strict';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import isNumber from 'lodash/isNumber';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ClockComponent} from '../../../core-components/clock';
import {getItemClass} from '../../../core-utilities/redux/utils';
import {propsFromModel} from '../../controllers/TaskInfoTimerController';
import {ActiveTimerItemView} from './ActiveTimerItemView';


export class BaseActiveTimerItemComponent extends Component {
  static propTypes = {
    userId: T.string.isRequired,
    model: T.object,

    onClick: T.func,
    onContextMenu: T.func,
    onClickStart: T.func,
    onClickPause: T.func,
    onClickStop: T.func,
  };

  static viewProps = {};

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.handleClickStart = this.handleClickStart.bind(this);
    this.handleClickPause = this.handleClickPause.bind(this);
    this.handleClickStop = this.handleClickStop.bind(this);
  }

  handleClick(e) {
    if (isFunction(this.props.onClick)) {
      e.preventDefault();
      this.props.onClick(e, this.props.model);
    }
  }

  handleContextMenu(e) {
    if (isFunction(this.props.onContextMenu)) {
      e.preventDefault();
      this.props.onContextMenu(e, this.props.model);
    }
  }

  handleClickStart(e) {
    if (isFunction(this.props.onClickStart)) {
      e.preventDefault();
      this.props.onClickStart(e, this.props.model);
    }
  }

  handleClickPause(e) {
    if (isFunction(this.props.onClickPause)) {
      e.preventDefault();
      this.props.onClickPause(e, this.props.model);
    }
  }

  handleClickStop(e) {
    if (isFunction(this.props.onClickStop)) {
      e.preventDefault();
      this.props.onClickStop(e, this.props.model);
    }
  }

  render() {
    const model = this.props.model || {};
    const modelProps = propsFromModel(model, BaseActiveTimerItemComponent.viewProps);

    let elapsedTime = isNumber(modelProps.totalTime) ? modelProps.totalTime : 0;
    if (modelProps.isStarted) {
      elapsedTime += new Date().getTime() - modelProps.startedAt;
    }

    return (
      <ActiveTimerItemView
        className={classNames(this.props.className, getItemClass(model))}

        targetName={get(model, 'target.value')}
        parentName={model.parentName}
        elapsedTime={elapsedTime}

        onClick={this.handleClick}
        onContextMenu={this.handleContextMenu}
        onClickStart={this.handleClickStart}
        onClickPause={this.handleClickPause}
        onClickStop={this.handleClickStop}

        {...modelProps}
      />
    );
  }
}

export const ActiveTimerItemComponent = ClockComponent(BaseActiveTimerItemComponent, 1000);



// WEBPACK FOOTER //
// ./src/js/timers/components/ActiveTimerItem/ActiveTimerItemComponent.js